import React from "react";
import spinSvg from "@/assets/svg/spin-small.svg";
import Image from "next/image";

const LoadingSpinnerSmall = () => {
  return <Image src={spinSvg} alt="Spinner" />;
};

export default LoadingSpinnerSmall;
